module.exports = __webpack_public_path__ + "static/media/background-faqs.4c39bcd7.jpg";